import 'datatables.net';
import $ from 'jquery';
import React, {memo, useEffect, useState} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import NewProjectViewComponent from '../../Components/Projekte/NewProjectViewComponent';
import '../../Styles/Projekte.css';
import {useHistory} from 'react-router-dom';
import {getOut, getToken} from "../../Utils/Common";


function ProjektsComponent() {

    const [projekteTableBody, setProjekteTableBody] = useState(<></>);
    const [, setProjectInformation] = useState({});
    let history = useHistory();

    let prepareProjektTableBody = (result) => {
        let projekteTableBodyData = result.map(({
                                                    _id,
                                                    projectID,
                                                    customerIdentificator,
                                                    projectName,
            projectStatus,
            customerReference
                                                }) =>
            <tr key={_id}>
                <td>{projectID}</td>
                <td>{projectStatus}</td>
                <td>{customerIdentificator}</td>
                <td>{projectName}</td>
                <td>{customerReference}</td>
                <td className='centerStyle'><Button
                    onClick={async () => {

                        let apiBody = {
                            "token": getToken(),
                            "data": {
                                "projectID": projectID
                            }
                        }
                        let agData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/auftraggeberList", {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json',
                            },
                            body: JSON.stringify(apiBody),
                        })
                            .then((response) => response.json())
                            .catch((error) => {
                                console.error('Error:', error);
                            })

                        let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getoneprojectplan", {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json',
                            },
                            body: JSON.stringify(apiBody),
                        })
                            .then((response) => response.json())
                            .catch((error) => {
                                console.error('Error:', error);
                            })

                        setProjectInformation(res)


                        let planDescriptions = res.plan.planData.map(({
                                                                          description
                                                                      }) => description)


                        let planObjectPaths = res.plan.planData.map(({
                                                                         objectPath
                                                                     }) => objectPath)



                        //let planLinks = [];
                        let planLinks = {};

                        Promise.all(planObjectPaths.map(async (objectPath) => {

                            let apiBody = {
                                "token": getToken(),
                                "data": {
                                    "object_path": objectPath
                                }
                            }


                            let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getpresignedurl", {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json',
                            },
                            body: JSON.stringify(apiBody),
                        })
                            .then((response) => response.json())
                            .catch((error) => {
                                console.error('Error:', error);
                            })
                            planLinks[objectPath]=res

                        })).then(() => {

                            history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTPAGE,
                                {
                                    projectInformation: res,
                                    planDescriptions: planDescriptions,
                                    planLinks: planLinks,
                                    agData: agData
                                })
                            console.log(res,planDescriptions,planLinks,agData)


                        })


                    }


                    }

                    className='handwai-btn-create'>Bearbeiten</Button>{' '}</td>
            </tr>
        );

        setProjekteTableBody(projekteTableBodyData);

    };

    useEffect(async () => {

        let apiBody = {
            "token": getToken(),
            "data": {
                "organisationID": sessionStorage.getItem("org")
            }
        }

        //let serverResponse = await fetch(process.env.REACT_APP_MOCK_API + "/readprojects", {
        let serverResponse = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/readprojects", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        if (serverResponse.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        } else {
            prepareProjektTableBody(serverResponse.data);
        }
        // Datatable initialisation
        $('#projektTable').DataTable({
            dom: 'frtilp',
            language: {
                fontcolor: 'white',
                url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            },
            oLanguage: {
                sSearch: '',
                searchPlaceholder: 'Suchen'
            },
            order: [[1, 'asc']]
        });


    }, []);

    return (
        <>
            <br/> <br/>
            <div className='container handwai-dark'>
                <Row>
                    <Col md={10}/>
                    <Col md={2}>
                        <NewProjectViewComponent/>
                    </Col>
                </Row>
                <table id='projektTable'
                       className='table'>
                    <thead>
                    <tr>
                        <th data-sortable='true' data-searchable='true'>
                            ID
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Status
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Auftrag Nr
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Name
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Kunden Reference
                        </th>
                        <th className='centerStyle'>Aktivität</th>
                    </tr>
                    </thead>
                    <tbody
                        className='handwai-text-label-normal'>{projekteTableBody}</tbody>
                </table>
                <br/> <br/>
            </div>
        </>
    );
}

export default memo(ProjektsComponent);